import React from 'react';
import PropTypes from 'prop-types';

function TabContentItem({ activeTab, tabIndex, className, id, children }) {
  return (
    <div
      id={id}
      data-tabs-pane
      className={`tabs-pane${
        activeTab === tabIndex ? ' active' : ''
      } ${className}`}
    >
      {activeTab === tabIndex ? children : null}
    </div>
  );
}

TabContentItem.propTypes = {
  id: PropTypes.number,
  activeTab: PropTypes.number,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.any,
};

TabContentItem.defaultProps = {
  activeTab: 0,
  tabIndex: 0,
  className: '',
};

export default TabContentItem;
